module.exports = __webpack_public_path__ + "static/media/picture-8@2x.8ae2eea1.png";